import { useInfiniteQuery } from '@tanstack/react-query';

import statementsClient, { StatementItemType } from '@clients/statementsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getStatements } = statementsClient();

export type StatementProps = {
    accountId: string;
    enabled?: boolean;
};

const useGetStatements = ({ accountId, enabled = true }: StatementProps) => {
    const {
        data,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
        isFetching,
    } = useInfiniteQuery(
        ['statementDetails', accountId],
        ({ pageParam }) =>
            getStatements({
                accountId: accountId,
                page: pageParam,
                perPage: 1,
            }),
        {
            enabled,
            getNextPageParam: (lastPage) =>
                lastPage.is_last_page ? undefined : lastPage.current_page + 1,
            onError: notifyAPIError,
        },
    );

    let statements: StatementItemType[] = [];
    const flattenPages = data?.pages?.flat(1);

    if (flattenPages) {
        statements = flattenPages.reduce((previousValue, currentValue) => {
            if (currentValue.items === null) return previousValue;
            return [...previousValue, ...currentValue?.items];
        }, []);
    }
    return {
        data: statements,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
        isFetching,
    };
};

export default useGetStatements;
